import { render, staticRenderFns } from "./injuryrecordDetail.vue?vue&type=template&id=67230ca9&"
import script from "./injuryrecordDetail.vue?vue&type=script&lang=js&"
export * from "./injuryrecordDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports